module.exports = __webpack_public_path__ + "images/icons_v2/volume-low-filled-f37adfca.svg";